import "./Css/MostLikedGame.css";
import { useState, useEffect, useContext } from "react";
import { AppContext } from "../../context/AppContext";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";

const MostLikedGame = () => {
  const {
    baseUrl,
    gameUrl,
    Backend_folder_path,
    addGameUrl,
    setCategory,
    addThumbImg,
    gameList,
    setgamelist,
    setdescreption,
    setPageRefreshCount,
    metaTag,
    setgametitle,
    setmetadata,
    setgametype,
    setgameid,
    setappstorelink,
    AppStoreLink,
    setThumbImgStatus,
    setGameIframeStatus,
  } = useContext(AppContext);
  const [cardsData, setCardsData] = useState([]);
  const navigate = useNavigate();
  const [gameLists, setGameList] = useState([]);
  const getMostLokedGameData = async () => {
    try {
      const response = await axios.get(`${baseUrl}/getmost_liked`);
      if (response) {
        setGameList(response.data.data);

        //setCategory(response.data.data);
      }
    } catch (error) {
      //console.error('Error saving category:', error);
    }
  };
  useEffect(() => {
    const newCards = gameLists.map((game, index) => ({
      title: `${game.game_title}`, // optional formatting
      id: index + 1,
      path: `${Backend_folder_path}${game.folder_path}/index.html`,
      thumb_img: `${Backend_folder_path}${game.thumbnail_img_path}`,
      url: game.url,
      category: game.category,
      descreption: game.description,
      enable: game.enable,
      title: game.game_title,
      meta_title: game.meta_title,
      meta_keyword: game.meta_keyword,
      meta_description: game.meta_description,
      gameType: game.gameType,
      gameId: game.id,
      iso_link: game.iso_link,
      playstore_link: game.playstore_link,
    }));
    setCardsData(newCards);
  }, [gameLists]);
  useEffect(() => {
    getMostLokedGameData();
  }, []);
  const handleClick = (game) => {
    // navigate to the game layout with selected image
    setGameIframeStatus(false);
    setThumbImgStatus(true);
    const url = game.url;
    addGameUrl(game.path);
    addThumbImg(game.thumb_img);
    setCategory(game.category);
    setdescreption(game.descreption);
    setgametitle(game.title);
    setmetadata({
      title: game.meta_title,
      keywords: game.meta_keyword,
      descreption: game.meta_description,
    });
    setgametype(game.gameType);
    setgameid(game.gameId);
    setappstorelink({
      ...AppStoreLink,
      iso_link: game.iso_link,
      playstore_link: game.playstore_link,
    });
    const titleTag = document.querySelector("head > title");
    titleTag.textContent = game.title
      .replace(/-/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());

    navigate(`/game/${url}`);
    setTimeout(() => {
      window.scrollTo({ top: "59", behavior: "smooth" });
    }, 100);
  };
  return (
    <>
      <div className="most-liked-game">
        <div
          style={{
            textAlign: "center",
            color: "white",
            fontSize: "28px",
            fontWeight: 700,
          }}
        >
          Most Popular Game
        </div>
        <div className="game-grid">
          {cardsData.map(
            (game) =>
              game.enable && (
                <div
                  style={{ cursor: "pointer" }}
                  className="game-card"
                  key={game.id}
                >
                  <img
                    onClick={() => handleClick(game)}
                    src={game.thumb_img}
                    alt={game.title}
                  />
                  <div className="hover-title">{game.title}</div>
                </div>
              )
          )}
        </div>
      </div>
    </>
  );
};
export default MostLikedGame;
